/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { ContentAiUpdateUserArticleContentMutationRequest, ContentAiUpdateUserArticleContentMutationResponse, ContentAiUpdateUserArticleContentPathParams, ContentAiUpdateUserArticleContent401, ContentAiUpdateUserArticleContent403 } from "../models/ContentAiUpdateUserArticleContent";

export function getContentAiUpdateUserArticleContentUrl(id: ContentAiUpdateUserArticleContentPathParams["id"]) {
  const res = { method: 'PUT', url: `/content-ai/v1/contents/${id}/user-article` as const }
  return res
}

/**
 * @summary Set article content after user edition
 * {@link /content-ai/v1/contents/:id/user-article}
 */
export async function contentAiUpdateUserArticleContent(id: ContentAiUpdateUserArticleContentPathParams["id"], data: ContentAiUpdateUserArticleContentMutationRequest, config: Partial<RequestConfig<ContentAiUpdateUserArticleContentMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<ContentAiUpdateUserArticleContentMutationResponse, ResponseErrorConfig<ContentAiUpdateUserArticleContent401 | ContentAiUpdateUserArticleContent403>, ContentAiUpdateUserArticleContentMutationRequest>({ method : "PUT", url : getContentAiUpdateUserArticleContentUrl(id).url.toString(), data : requestData, ... requestConfig })
  return res.data
}